import { VotingWidget } from './VotingWidget';
import { ProposalMeta } from './ProposalMeta';
import { ProposalTags } from './ProposalTags';
import { ProposalHistoryPreview } from './ProposalHistoryPreview';

/**
 * Proposal Card Component
 * Displays individual proposal with voting widget
 */
export function ProposalCard({ proposal, onClick, onVote, voting, showVoting, userVote }) {
  // Parse metadata
  const metadata = proposal.metadata ? (typeof proposal.metadata === 'string' ? JSON.parse(proposal.metadata) : proposal.metadata) : {};
  const tags = metadata.tags || [];
  const attachments = metadata.attachments || [];
  // Parse vote counts
  const votesFor = parseInt(proposal.votes_for || 0);
  const votesAgainst = parseInt(proposal.votes_against || 0);
  const votesAbstain = parseInt(proposal.votes_abstain || 0);
  const quorum = parseInt(proposal.quorum_required || 10);

  return (
    <div className="t24-proposal-card" onClick={onClick}>
      {/* Card Header with Category and Priority */}
      <div className="t24-proposal-card-header">
        <span className={`t24-proposal-category-badge ${proposal.category}`}>
          {window.t24Governance.categories[proposal.category] || proposal.category}
        </span>
        {proposal.priority && (
          <span className={`t24-proposal-priority-badge ${proposal.priority}`}>
            {proposal.priority}
          </span>
        )}
      </div>

      {/* Title */}
      <h4 className="t24-proposal-title">{proposal.title}</h4>

      {/* Description Preview */}
      <p className="t24-proposal-description">
        {proposal.description.length > 150
          ? proposal.description.substring(0, 150) + '...'
          : proposal.description}
      </p>

      {/* Tags */}
      {tags.length > 0 && (
        <ProposalTags tags={tags} />
      )}

      {/* Attachments Indicator */}
      {attachments.length > 0 && (
        <div className="t24-proposal-attachments-indicator">
          <span className="attachment-icon">📎</span>
          <span className="attachment-count">{attachments.length} attachment{attachments.length !== 1 ? 's' : ''}</span>
        </div>
      )}

      {/* History Preview */}
      <ProposalHistoryPreview proposalId={proposal.id} />

      {/* Voting Widget */}
      {showVoting && (
        <VotingWidget
          proposalId={proposal.id}
          votesFor={votesFor}
          votesAgainst={votesAgainst}
          votesAbstain={votesAbstain}
          quorum={quorum}
          onVote={(voteType) => {
            // Event handling is already done in VotingWidget buttons
            onVote(proposal.id, voteType);
          }}
          voting={voting}
          userVote={userVote}
        />
      )}

      {/* Proposal Meta (Author, Time Remaining) */}
      <ProposalMeta
        author={proposal.created_by}
        createdAt={proposal.created_at}
        endsAt={proposal.ends_at}
        status={proposal.status}
      />
    </div>
  );
}
